import React, { memo, useState } from 'react'
import { Provider } from 'react-redux'
import './app.sass'
import { CareInformationSection } from './components/CareInformationSection'
import { CareSelectionSection } from './components/CareSelectionSection'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { SimulationResult } from './components/SimulationResult'
import { store } from './redux/store'
import Measure, { ContentRect } from 'react-measure'

const postMessage = (type: string, data = {}) => {
  if (top !== self) {
    window.parent.postMessage(
      {
        eventType: type,
        data,
      },
      '*'
    )
  }
}

const heightChanged = (height: number) => {
  postMessage('heightChanged', { height })
}

export default memo(function App() {
  const [dimensions, setDimensions] = useState({ height: -1, width: -1 })

  const onResize = (contentRect: ContentRect) => {
    setDimensions(contentRect.bounds)

    const height = contentRect.bounds.height

    if (height !== null && dimensions.height !== height) {
      heightChanged(height)
    }
  }

  return (
    <Provider store={store}>
      <Measure bounds onResize={onResize}>
        {({ measureRef }) => (
          <div ref={measureRef}>
            <Header />
            <CareSelectionSection />
            <CareInformationSection />
            <SimulationResult />
            <Footer />
          </div>
        )}
      </Measure>
    </Provider>
  )
})
